import { Outlet, createFileRoute } from '@tanstack/react-router'
import { Stack } from '@astryxdesign/core/Stack'
import { Text } from '@astryxdesign/core/Text'
import { useMe } from '#/lib/hooks'
import { isAdmin } from '#/lib/types'

export const Route = createFileRoute('/manage')({ component: Manage })

/**
 * Everything behind the burger. Co-travellers reach Documents through here too,
 * so the gate is per-section rather than on the whole branch.
 */
function Manage() {
  const me = useMe()
  return (
    <Stack direction="vertical" gap={4}>
      <Outlet />
      {me && !isAdmin(me.role) && (
        <Text type="supporting">
          Some sections are admin-only and are hidden from this menu.
        </Text>
      )}
    </Stack>
  )
}
